import React from "react"

const HomeIcon = ({ size }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512.001 512.001"
    aria-hidden="true"
    focusable="false"
    fill="currentColor"
  >
    <g>
      <g>
        <g>
          <path
            d="M225.334,256.739c-2.067-0.924-4.417-0.986-6.53-0.174c-2.113,0.812-3.816,2.433-4.732,4.503l-34.133,76.8
				c-1.915,4.305,0.024,9.348,4.329,11.262c4.306,1.915,9.348-0.024,11.263-4.329l34.133-76.8c0.92-2.068,0.981-4.416,0.169-6.528
				C229.02,259.361,227.402,257.657,225.334,256.739z"
          />
          <path
            d="M97.684,367.834c-2.024-1.012-4.368-1.179-6.515-0.463s-3.922,2.255-4.935,4.28l-34.133,68.267
				c-2.094,4.214-0.383,9.328,3.826,11.432c4.209,2.104,9.327,0.405,11.441-3.799l34.133-68.267
				c1.013-2.024,1.179-4.368,0.463-6.516C101.248,370.621,99.709,368.846,97.684,367.834z"
          />
          <path
            d="M387.817,367.834c-4.216-2.107-9.342-0.399-11.45,3.817l-34.133,68.267c-2.094,4.214-0.383,9.328,3.826,11.432
				s9.327,0.405,11.441-3.799l34.133-68.267c1.013-2.024,1.179-4.368,0.463-6.516C391.382,370.621,389.842,368.846,387.817,367.834z
				"
          />
          <path
            d="M408.701,269.251c-1.603-2.69-4.502-4.338-7.633-4.338s-6.031,1.648-7.633,4.338l-26.5,53l-54.458-108.917h173.925
				c14.132-0.015,25.585-11.468,25.6-25.6c-0.066-14.111-11.489-25.534-25.6-25.6H349.867c-2.298,0.007-4.497-0.937-6.075-2.608
				c-1.592-1.558-2.479-3.698-2.458-5.925c0.006-4.71,3.823-8.527,8.533-8.533h93.867c14.132-0.015,25.585-11.468,25.6-25.6
				c-0.066-14.111-11.489-25.534-25.6-25.6H298.667c-4.71-0.006-8.527-3.823-8.533-8.533c-0.007-2.298,0.937-4.497,2.608-6.075
				c1.558-1.592,3.698-2.479,5.925-2.458h17.067c14.111-0.066,25.534-11.489,25.6-25.6c-0.015-14.132-11.468-25.585-25.6-25.6
				H25.601c-6.759-0.049-13.25,2.642-17.992,7.458c-4.897,4.762-7.643,11.312-7.608,18.142c0.015,14.132,11.468,25.585,25.6,25.6
				h136.533c4.71,0.006,8.527,3.823,8.533,8.533c0.007,2.298-0.937,4.497-2.608,6.075c-1.558,1.592-3.698,2.479-5.925,2.458H93.867
				c-14.111,0.066-25.534,11.489-25.6,25.6c0.015,14.132,11.468,25.585,25.6,25.6h68.267c2.298-0.007,4.497,0.937,6.075,2.608
				c1.592,1.558,2.479,3.698,2.458,5.925c-0.006,4.71-3.823,8.527-8.533,8.533H25.601c-14.132,0.015-25.585,11.468-25.6,25.6
				c-0.049,6.759,2.642,13.25,7.458,17.992c4.762,4.896,11.312,7.643,18.142,7.608h173.925l-54.458,108.917l-26.5-53
				c-1.603-2.69-4.502-4.338-7.633-4.338s-6.031,1.648-7.633,4.338l-102.4,204.8c-1.322,2.645-1.181,5.787,0.374,8.303
				c1.555,2.516,4.302,4.047,7.259,4.047h494.933c2.958,0,5.704-1.531,7.259-4.047c1.555-2.516,1.697-5.657,0.374-8.303
				L408.701,269.251z M401.067,292.147l9.658,19.317l-12.025,18.037l-12.233-8.155L401.067,292.147z M25.601,196.268
				c-2.298,0.007-4.497-0.937-6.075-2.608c-1.592-1.558-2.479-3.698-2.458-5.925c0.006-4.71,3.823-8.527,8.533-8.533h136.533
				c14.132-0.015,25.585-11.468,25.6-25.6c-0.066-14.111-11.489-25.534-25.6-25.6H93.867c-4.71-0.006-8.527-3.823-8.533-8.533
				c-0.007-2.298,0.937-4.497,2.608-6.075c1.558-1.592,3.698-2.479,5.925-2.458h68.267c14.111-0.066,25.534-11.489,25.6-25.6
				c-0.015-14.132-11.468-25.585-25.6-25.6H25.601c-4.71-0.006-8.527-3.823-8.533-8.533c-0.007-2.298,0.937-4.497,2.608-6.075
				c1.558-1.592,3.698-2.479,5.925-2.458h290.133c4.71,0.006,8.527,3.823,8.533,8.533c0.007,2.298-0.937,4.497-2.608,6.075
				c-1.558,1.592-3.698,2.479-5.925,2.458h-17.067c-14.111,0.066-25.534,11.489-25.6,25.6c0.015,14.132,11.468,25.585,25.6,25.6
				h145.067c2.298-0.007,4.497,0.937,6.075,2.608c1.592,1.558,2.479,3.698,2.458,5.925c-0.006,4.71-3.823,8.527-8.533,8.533h-93.867
				c-14.132,0.015-25.585,11.468-25.6,25.6c0.066,14.111,11.489,25.534,25.6,25.6h136.533c2.298-0.007,4.497,0.937,6.075,2.608
				c1.592,1.558,2.479,3.698,2.458,5.925c-0.006,4.71-3.823,8.527-8.533,8.533H303.942l-40.308-80.617
				c-1.603-2.69-4.502-4.337-7.633-4.337c-3.131,0-6.031,1.648-7.633,4.337l-40.308,80.617H25.601z M280.594,187.733l-9.864,19.73
				l-8.695-8.695c-1.6-1.601-3.77-2.5-6.033-2.5c-2.263,0-4.433,0.899-6.033,2.5l-8.695,8.695l-9.865-19.73l24.593-49.186
				L280.594,187.733z M110.934,292.147l14.599,29.199l-12.233,8.155l-12.025-18.037L110.934,292.147z M76.801,469.334H22.342
				l70.143-140.29l11.349,17.023c1.255,1.883,3.207,3.19,5.426,3.634s4.524-0.012,6.407-1.268l17.557-11.705l66.301,132.605H76.801z
				 M218.609,469.334l-64-128l67.258-134.518l9.434,18.868c1.226,2.454,3.558,4.169,6.266,4.608
				c2.708,0.439,5.462-0.451,7.401-2.391l11.034-11.033l11.034,11.034c1.6,1.6,3.77,2.5,6.033,2.5
				c0.458-0.001,0.915-0.037,1.367-0.108c2.708-0.441,5.039-2.155,6.267-4.608l9.434-18.868l67.258,134.518l-64,128H218.609z
				 M435.201,469.334H312.476l66.301-132.605l17.557,11.704c1.883,1.255,4.188,1.711,6.407,1.268
				c2.219-0.444,4.171-1.751,5.427-3.634l11.348-17.023l70.143,140.29H435.201z"
          />
        </g>
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
)
export default HomeIcon
